<template>
	<v-dialog v-model="dialog" max-width="400px" hide-overlay>
		<template v-slot:activator="{ on }">
			<v-btn color="#1A237E" class="text-lowercase" icon v-on="on">
				<v-tooltip bottom>
					<template v-slot:activator="{ on }">
						<v-icon small v-on="on">mdi-cart-off</v-icon>
					</template>
					<span>suspend from chain</span>
				</v-tooltip>
			</v-btn>
		</template>
		<v-card v-if="!loading" class="text-md-center">
			<v-card-title class="pt-4 black--text">
				<span class="subtitle-2">Would you like to suspend from the
					<span class="accentColor">{{ this.chan.name }}</span>?
				</span>
			</v-card-title>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="#1A237E" text
					class="text-capitalize" 
					@click="closeDialog">
					No
				</v-btn>
				<v-btn color="#1A237E" text
					class="text-capitalize"
					@click="deleteChannel"
					>Yes</v-btn>
			</v-card-actions>
		</v-card>
		<div v-else class="text-center">
			<loader></loader>
		</div>
	</v-dialog>
</template>

<script>
	import Loader from '../../layouts/Loader.vue'

	export default {
		props: ['chan', 'gameId', 'round'],
		data () {
			return	{
				dialog: false
			}
		},
		computed: {
			loading () {
				return this.$store.getters.loading
			}, 
			inIndependentChains () {
				return this.$store.getters.inIndependentChains
			}
		},
		methods: {
			async deleteChannel () {
				const ch = this.inIndependentChains.find(channel => channel.chainId == this.chan.id)
				//console.log(ch)
				if (ch) {
					try {
						//delete Channel 
						await this.$store.dispatch('deleteChannel', {
							channel: ch.id,
							gameId: this.gameId,
							round: this.round
						})
						this.closeDialog ()					
					}
					catch (error) {
						this.error = error.message
					}
				}				
			},
			closeDialog () {
				//reset
				this.dialog = false
				this.error = ''
			}
		},
		components: {Loader}
	}
</script>
<style>
	.error{
		color: white
	}
</style>